<div class="loading" *ngIf="loading == true">Loading&#8230;</div>
<main style="background-color: white" id="main">
    <div class="content content-padding">
        <div class="container">
            <!--Form section block-->
            <section>
                <div class="row mt-3 no-gutters">
                    <div class="col-4 px-1" *ngFor="let header of formHeaders">
                        <button class="form-section form-section-button active-form-section"
                            [ngClass]="{ 'active-form-section': pageNumber >= header.key }"
                            [disabled]="pageNumber <= header.key || pageNumber == 3"
                            (click)="selectPage(header.key)">
                            <div class="heading-3-light">{{header.value}}</div>
                        </button>
                    </div>
                </div>
            </section>
            <section>
                <div [hidden]="pageNumber != 1">
                    <app-valuer-information (pageNumberEvent)="changePage($event)"
                    (ValuerInformationEvent)="assignValuerInformation($event)">
                    </app-valuer-information>
                </div>
                <div [hidden]="pageNumber != 2">
                    <app-valuer-submit-documents (pageNumberEvent)="changePage($event)"
                    (uploadFilesEvent)="assignFiles($event)">
                    </app-valuer-submit-documents>
                </div> 
                <div [hidden]="pageNumber != 3">
                    <app-valuer-sign-contract>
                    </app-valuer-sign-contract>
                </div>
            </section>
        </div>
    </div>
</main>